import { render, staticRenderFns } from "./FundRecord.vue?vue&type=template&id=a60f2c24&scoped=true&"
import script from "./FundRecord.vue?vue&type=script&lang=js&"
export * from "./FundRecord.vue?vue&type=script&lang=js&"
import style0 from "./FundRecord.vue?vue&type=style&index=0&id=a60f2c24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60f2c24",
  null
  
)

export default component.exports